export interface CouleurChantier {
  id: string;
  label: string;
  hex: string;
  bgClass: string;    // Classe Tailwind pour le fond
  textClass: string;  // Classe Tailwind pour le texte
}

// Palette Industriel/Chantier - Couleurs corporate et masculines
export const COULEURS_CHANTIER: CouleurChantier[] = [
  { id: 'navy', label: 'Navy', hex: '#1e3a5f', bgClass: 'bg-blue-900', textClass: 'text-blue-900' },
  { id: 'acier', label: 'Bleu acier', hex: '#2563eb', bgClass: 'bg-blue-600', textClass: 'text-blue-600' },
  { id: 'teal', label: 'Teal', hex: '#0f766e', bgClass: 'bg-teal-700', textClass: 'text-teal-700' },
  { id: 'foret', label: 'Vert forêt', hex: '#15803d', bgClass: 'bg-green-700', textClass: 'text-green-700' },
  { id: 'cuivre', label: 'Cuivre', hex: '#b45309', bgClass: 'bg-amber-700', textClass: 'text-amber-700' },
  { id: 'terracotta', label: 'Terracotta', hex: '#9a3412', bgClass: 'bg-orange-800', textClass: 'text-orange-800' },
  { id: 'beton', label: 'Béton', hex: '#6b7280', bgClass: 'bg-gray-500', textClass: 'text-gray-500' },
  { id: 'violet', label: 'Violet', hex: '#7c3aed', bgClass: 'bg-violet-600', textClass: 'text-violet-600' },
  { id: 'bordeaux', label: 'Bordeaux', hex: '#be185d', bgClass: 'bg-pink-700', textClass: 'text-pink-700' },
  { id: 'ardoise', label: 'Ardoise', hex: '#475569', bgClass: 'bg-slate-600', textClass: 'text-slate-600' },
];

// Helper pour trouver une couleur par son hex
export function getCouleurByHex(hex: string): CouleurChantier | undefined {
  return COULEURS_CHANTIER.find(c => c.hex === hex);
}
